import gql from 'graphql-tag';

import rejectedDuplicateFileFragment from '../fragments/rejectedDuplicateFileFragment';

export const mutationCreateRejectedDuplicateFile = gql`
  mutation createRejectedDuplicateFiles (
    $fileContentMD5s: [String!]!
  ) {
    createRejectedDuplicateFiles (
      fileContentMD5s: $fileContentMD5s
    ) {
      ...rejectedDuplicateFileFragment
    }
  }
  ${rejectedDuplicateFileFragment}
`;
export default mutationCreateRejectedDuplicateFile;
